import axios from '.';

export default {
  getIceServersData,
};

async function getIceServersData() {
  const response = await axios.get('twilio/ice-servers');
  return response?.data;
}
